import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as CalendarIcon } from 'Assets/svg/calendar.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { defaultDateValue, EMPTY_FUNCTION } from 'Utils/constants';
import { format } from 'date-fns';
import { DateRange } from 'react-date-range';
import { userDetail } from 'Stores/userDetail';
import Button from '../Button';
import './styles.scss';

const DateRangePicker = props => {
  const {
    onClose,
    onSubmit,
    onCancel = EMPTY_FUNCTION,
    maxDate,
    defaultValue = defaultDateValue,
    closeIcon = true,
    editableDateInputs = true,
  } = props;
  const filterDateRef = useRef();
  const [showDateSelectionPopup, setShowDateSelectionPopup] = useState(false);
  const [dateRange, setDateRange] = useState({
    popup: defaultValue,
    value: defaultValue,
  });

  function handleClickOutside(event) {
    if (
      filterDateRef.current &&
      !filterDateRef.current?.contains(event.target) &&
      showDateSelectionPopup
    ) {
      setShowDateSelectionPopup(false);
      setDateRange({ ...dateRange, popup: dateRange.value });
    }
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (showDateSelectionPopup) {
      // eslint-disable-next-line no-undef
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        // eslint-disable-next-line no-undef
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [showDateSelectionPopup]);

  return (
    <div
      ref={filterDateRef}
      className={`filter-date${showDateSelectionPopup ? ' popup-open' : ''}`}
      onClick={() => setShowDateSelectionPopup(true)}
    >
      <CalendarIcon className="calendar-icon" />
      {dateRange.value.startDate !== null &&
      dateRange.value.endDate !== null ? (
        // eslint-disable-next-line no-unwrapped-jsx/no-unwrapped-jsx-text
        <span className="selected-date-range">
          {format(dateRange.value.startDate, 'dd MMM yyyy')} -{' '}
          {format(dateRange.value.endDate, 'dd MMM yyyy')}
          {closeIcon && (
            <CloseIcon
              title="Click here to clear date range"
              onClick={e => {
                e.stopPropagation();
                onClose();
                setDateRange({
                  popup: defaultValue,
                  value: defaultValue,
                });
              }}
            />
          )}
        </span>
      ) : (
        <span className="filter-text">Filter by Date</span>
      )}
      {showDateSelectionPopup && (
        <div className="date-selection-popup">
          <div className="date-range-wrapper">
            <DateRange
              editableDateInputs={editableDateInputs}
              onChange={item => {
                setDateRange({ ...dateRange, popup: item.selection });
              }}
              moveRangeOnFirstSelection={false}
              ranges={[dateRange.popup]}
              startDatePlaceholder="From"
              endDatePlaceholder="To"
              minDate={
                new Date(
                  userDetail.userInfo.memberSubscription.creationTimeStamp,
                )
              }
              maxDate={maxDate || new Date()}
            />
          </div>
          <div className="button-wrapper">
            <Button
              disabled={
                JSON.stringify(dateRange.popup) ===
                JSON.stringify(dateRange.value)
              }
              className="cancel"
              btnText="Cancel"
              type="button"
              click={e => {
                e.stopPropagation();
                onCancel();
                setDateRange({ ...dateRange, popup: dateRange.value });
                setShowDateSelectionPopup(false);
              }}
            />
            <Button
              disabled={
                JSON.stringify(dateRange.popup) ===
                JSON.stringify(dateRange.value)
              }
              className="apply"
              btnText="Apply"
              type="button"
              click={e => {
                e.stopPropagation();
                setShowDateSelectionPopup(false);
                setDateRange({ ...dateRange, value: dateRange.popup });
                onSubmit(dateRange.popup);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
